/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropentrystateforfeited3Inputs */

const en_dropentrystateforfeited3 = /** @type {(inputs: Dropentrystateforfeited3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forfeited`)
};

const de_dropentrystateforfeited3 = /** @type {(inputs: Dropentrystateforfeited3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfallen`)
};

/**
* | output |
* | --- |
* | "Forfeited" |
*
* @param {Dropentrystateforfeited3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropentrystateforfeited3 = /** @type {((inputs?: Dropentrystateforfeited3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropentrystateforfeited3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropentrystateforfeited3(inputs)
	return de_dropentrystateforfeited3(inputs)
});
export { dropentrystateforfeited3 as "dropEntryStateForfeited" }